export default {
  callCenterStatus: 0,
  callListId: 0,
  currentRecording: {},
  notification: {},
  extensionNumber: 0,
  extension: {},
  softPhone: {},
  call: {},
  callRecordingId: '',
  callRecordingState: false,
  disconnectReasons: [
    'Fin de jornada',
    'Colación',
    'Ir al baño',
    'Reunión',
    'Break',
    'Falla de internet',
    'Recarga',
    'Otro',
  ],
  callsToSave: [],
  extensions: [],
  keepCalling: false,
  isRecording: false,
  disconnectReason: '',
  conferenceId: '',
  callType: '',
  maxCommitmentDays: null,
  reconnecting: false,
  isManualCallLoading: false,
};



// WEBPACK FOOTER //
// ./src/store/dialer/moduleDialerState.js